import z from "zod"
import { ConceptValueDataType } from "../ConceptValueDataType"

// in an effort to avoid moving the entire Concept interface to backcompat
// when it doesn't fully need to be backward compatible,
// we'll use a subset of the interface here like we do in Concept.go

export const ZXflowConcept = z.object({
	cid: z.string(),
	// these are nullable in formlib, but I couldn't tell you why...
	title: z.nullable(z.string()),
	valueDataType: z.nullable(z.enum(ConceptValueDataType)),
})
export type XflowConcept = z.infer<typeof ZXflowConcept>

export const ZXflowConceptsByCid = z.record(
	z.string(),  // cid
	ZXflowConcept,
)
export type XflowConceptsByCid = z.infer<typeof ZXflowConceptsByCid>
